import i18n from './i18n/config';
const { t } = i18n;

const BASE_URL = process.env.REACT_APP_API_URL;
const PSPDF_KEY = process.env.REACT_APP_PSPDFKIT_LICENSE_KEY;
const GRAVITY_PAYMENT_APPROVED_URL =
  process.env.REACT_APP_GRAVITY_PAYMENT_APPROVED_URL;
const GRAVITY_PAYMENT_DECLINED_URL =
  process.env.REACT_APP_GRAVITY_PAYMENT_DECLINED_URL;
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;
const DATABASE_VERSION = Number(process.env.REACT_APP_LOCAL_DBVERSION);
const DATABASE_NAME = process.env.REACT_APP_LOCAL_DBNAME;
const OFFLINE_DATABASE = process.env.REACT_APP_OFFLINE_DBNAME;

const LOCATION_URL = process.env.REACT_APP_LOCATION_URL;

localStorage.setItem('BASE_URL', BASE_URL);

/**
 * @description - This function will decide what we will do based on event
 * @param {*} event this will be an event from the trigger point
 * @param {*}
 * @param {*} object
 */
const handler = function (object, callback) {
  if (callback && typeof callback === 'function') {
    callback(object);
  }
};

// To be used when the class is removed from billing item
const PLACEHOLDER_CLASS = {
  id: '',
  name: t('billing.select_class')
};

const ESTIMATE_ACTION_KEYS = {
  PREVIEW_PDF: 'PREVIEW_PDF_ESTIMATE',
  EMAIL_PDF: 'EMAIL_ESTIMATE_PDF',
  CLONE: 'CLONE_ESTIMATE',
  TRANSFER: 'TRANSFER_ESTIMATE',
  CONVERT: 'CONVERT_TO_INVOICE',
  VOID: 'VOID_ESTIMATE',
  ATTACH_TO_TICKET: 'ATTACH_TO_TICKET',
}

const ESTIMATE_ACTIONS = [
  {
    path: '',
    name: t('billing.preview_pdf'),
    disabledAllowed: false,
    key: ESTIMATE_ACTION_KEYS.PREVIEW_PDF,
    handler,
    custom: 'handleDocumentModal'
  },
  {
    path: '',
    name: t('billing.email_estimate'),
    disabledAllowed: true,
    key: ESTIMATE_ACTION_KEYS.EMAIL_PDF,
    handler,
    custom: 'handleEmailModal'
  },
  {
    path: '',
    name: t('billing.estimate_clone'),
    disabledAllowed: false,
    key: ESTIMATE_ACTION_KEYS.CLONE,
    handler,
    custom: 'billingCloneConfirmation'
  },
  {
    path: '',
    name: t('billing.transfer_estimate'),
    disabledAllowed: true,
    key: ESTIMATE_ACTION_KEYS.TRANSFER,
    handler,
    custom: 'handleTransferEstimate'
  },
  {
    path: '',
    name: t('billing.convert_to_invoice'),
    disableAllowed: true,
    canConvertToInvoice: true,
    key: ESTIMATE_ACTION_KEYS.CONVERT,
    handler,
    custom: 'handleConvertEstimate'
  },
  {
    path: '',
    name: t('billing.estimate_void'),
    disabledAllowed: true,
    key: ESTIMATE_ACTION_KEYS.VOID,
    handler,
    custom: 'handleVoidInvoice'
  },
  {
    path: '',
    name: t('billing.attach_to_ticket'),
    disabledAllowed: true,
    key: ESTIMATE_ACTION_KEYS.ATTACH_TO_TICKET,
    handler,
    custom: 'handleAttachToTicket'
  }
];

const INVOICE_ACTION_KEYS = {
  PREVIEW_PDF: 'PREVIEW_PDF_INVOICE',
  CLONE: 'CLONE_INVOICE',
  EMAIL_PDF: 'EMAIL_INVOICE_PDF',
  TRANSFER: 'TRANSFER_INVOICE',
  ADD_SPIFF: 'ADD_SPIFF',
  VOID: 'VOID_INVOICE'
}

const INVOICE_ACTIONS = [
  {
    path: '',
    name: t('billing.preview_pdf'),
    disabledAllowed: false,
    key: INVOICE_ACTION_KEYS.PREVIEW_PDF,
    handler,
    custom: 'handleDocumentModal'
  },
  {
    path: '',
    name: t('billing.invoice_clone'),
    disabledAllowed: false,
    key: INVOICE_ACTION_KEYS.CLONE,
    handler,
    custom: 'billingCloneConfirmation'
  },
  {
    path: '',
    name: t('billing.email_invoice'),
    disabledAllowed: true,
    key: INVOICE_ACTION_KEYS.EMAIL_PDF,
    handler,
    custom: 'handleEmailModal'
  },
  {
    path: '',
    name: t('billing.transfer_invoice'),
    disabledAllowed: true,
    key: INVOICE_ACTION_KEYS.TRANSFER,
    handler,
    custom: 'handleTransferInvoice'
  },
  {
    path: '',
    name: t('billing.add_spiff'),
    disabledAllowed: true,
    key: INVOICE_ACTION_KEYS.ADD_SPIFF,
    handler,
    custom: 'handleAddSPIFF'
  },
  {
    path: '',
    name: t('billing.invoice_void'),
    disabledAllowed: true,
    key: INVOICE_ACTION_KEYS.VOID,
    handler,
    custom: 'handleVoidInvoice'
  }
];

const BILLING_PDF_EMAIL = [
  {
    path: '',
    name: t('billing.billing_email'),
    key: 'EMAIL_TYPE_BILL',
    handler
  },
  {
    path: '',
    name: t('billing.service_email'),
    key: 'EMAIL_TYPE_SERVICE',
    handler
  },
  {
    path: '',
    name: t('billing.custom_email'),
    key: 'EMAIL_TYPE_CUSTOM',
    handler
  },
  {
    path: '',
    name: t('billing.both_billing_service_email'),
    key: 'EMAIL_TYPE_BOTH',
    handler
  }
];

const RECEIVER_EMAIL_LIST = [
  { path: '', name: 'Billing e-mail', key: 'EMAIL_TYPE_BILL', handler },
  { path: '', name: 'Service e-mail', key: 'EMAIL_TYPE_SERVICE', handler },
  { path: '', name: 'Custom e-mail', key: 'EMAIL_TYPE_CUSTOM', handler },
  {
    path: '',
    name: 'Both service & billing e-mail',
    key: 'EMAIL_TYPE_BOTH',
    handler
  }
];

const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  {
    value: 'AS',
    label: 'American Samoa'
  },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  {
    value: 'CA',
    label: 'California'
  },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  {
    value: 'DE',
    label: 'Delaware'
  },
  { value: 'DC', label: 'District of Columbia' },
  {
    value: 'FM',
    label: 'Federated States Of Micronesia'
  },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  {
    value: 'GU',
    label: 'Guam'
  },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  {
    value: 'IL',
    label: 'Illinois'
  },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  {
    value: 'KS',
    label: 'Kansas'
  },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  {
    value: 'ME',
    label: 'Maine'
  },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MD', label: 'Maryland' },
  {
    value: 'MA',
    label: 'Massachusetts'
  },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  {
    value: 'MS',
    label: 'Mississippi'
  },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  {
    value: 'NE',
    label: 'Nebraska'
  },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  {
    value: 'NJ',
    label: 'New Jersey'
  },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  {
    value: 'NC',
    label: 'North Carolina'
  },
  { value: 'ND', label: 'North Dakota' },
  { value: 'MP', label: 'Northern Mariana Isl' },
  {
    value: 'OH',
    label: 'Ohio'
  },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  {
    value: 'PW',
    label: 'Palau'
  },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  {
    value: 'RI',
    label: 'Rhode Island'
  },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  {
    value: 'TN',
    label: 'Tennessee'
  },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  {
    value: 'VT',
    label: 'Vermont'
  },
  { value: 'VA', label: 'Virginia' },
  { value: 'VI', label: 'Virgin Islands' },
  {
    value: 'WA',
    label: 'Washington'
  },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  {
    value: 'WY',
    label: 'Wyoming'
  }
];

const CANADA_STATES = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  {
    value: 'MB',
    label: 'Manitoba'
  },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  {
    value: 'NS',
    label: 'Nova Scotia'
  },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  {
    value: 'ON',
    label: 'Ontario'
  },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  {
    value: 'SK',
    label: 'Saskatchewan'
  },
  { value: 'YT', label: 'Yukon Territory' }
];

const NEW_OBJECT_DEFAULT_IDS = {
  NEW_INVOICE: 'new_invoice_id',
  NEW_INVOICE_ITEM: 'new_item_id',
  NEW_ESTIMATE: 'new_estimate_id'
};

const PROFILES = {
  ADMINISTRATOR: 'Administrator',
  DISPATCHER: 'Dispatcher',
  SERVICE_MANAGER: 'Service Manager',
  TECHNICIAN: 'Technician',
  HELPER: 'Helper',
  TECHNICIAN_RESTRICTED: 'TechnicianRestricted',
  VIEW_RESTRICTED: 'ViewRestricted',
  BILLING_RESTRICTED: 'BillingRestricted'
};

const Payment_STATUS_IDS = {
  1: 'Complete',
  2: 'Open',
  3: 'Partial'
};

const ITEM_TYPE_IDS = {
  1: 'Custom',
  2: 'FlatRate',
  3: 'ServiceAgreement'
};

const BILLING_STATUS = {
  OPEN: "Open",
  COMPLETE: "Complete",
  VOID: "Void",
  SOLD: "Sold"
};

const BILLING_STATUS_ID = {
  OPEN: 1,
  COMPLETE: 2,
  VOID: 3,
  SOLD: 4
};

const ASSIGNMENT_STATUS_NAME = {
  COMPLETE: 'Complete',
  CANCEL: 'Cancel',
  DRIVING: 'Driving',
  ONBREAK: 'OnBreak',
  OPEN: 'Open',
  RESCHEDULE: 'Reschedule',
  WORKING: 'Working'
};


const VISIT_CANCEL_REASON_MIN_LENGTH = 8;
const VISIT_CANCEL_REASON_MAX_LENGTH = 45;

const emailType = {
  INVOICE: 0,
  ESTIMATE: 1,
  TICKET: 2
};

const BILLING_TYPE = {
  INVOICE: 0,
  ESTIMATE: 1
}

const ITEM_TYPES = {
  CUSTOM: 'Custom',
  FLATRATE: 'FlatRate',
  SERVICEAGREEMENT: 'ServiceAgreement',
  PMAFLATRATE: 'PMAFee'
};

var ACCEPTED_FILE_TYPES =
  'text/plain,.pdf,image/*,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.doc,.docx,.odt,.ppt,.pptx,.odp,.ods,video/*,.mkv,.flv,.3gp,.rmvb';

const SUPPORTED_FILE_MIME_TYPE = [
  'image/heif',
  'image/heic',
  'image/heic-sequence',
  'image/jpeg',
  'image/pjpeg',
  'image/x-citrix-jpeg',
  'image/png',
  'application/msword',
  'application/octet-stream',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/mspowerpoint',
  'application/powerpoint',
  'application/x-mspowerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.ms-excel',
  'application/excel',
  'application/x-excel',
  'application/x-msexcel',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/pdf',
  'text/plain',
  'text/csv',
  'application/octet-stream',
  'text/plain',
  'application/vnd.ms-excel',
  'image/x-icon',
  'image/vnd.microsoft.icon'
];
const SUPPORTED_VIDEO_FILE_MIME_TYPE = [
  'video/mp4',
  'video/quicktime',
  'video/x-ms-wmv',
  'application/x-troff-msvideo',
  'video/avi',
  'video/x-msvideo',
  'video/x-matroska',
  'video/x-flv',
  'video/mpeg',
  'video/3gpp',
  'video/webm',
  'application/vnd.rn-realmedia-vbr'
];

const SPIFF_STATUS = {
  5: 'SAVED',
  6: 'SUBMITTED',
  7: 'APPROVED',
  8: 'DECLINED'
};
const SPIFF_STATUS_ID = {
  submitted: 6,
  approved: 7,
  declined: 8
};

const ACTIONS = {
  DELETE: 'delete',
  UPDATE: 'update',
  CREATE: 'create'
};

const APPROVAL_STATUS = {
  APPROVED: 4,
  PENDING: 5,
  DECLINED: 6
};

const LINEITEM_STATUS = {
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED'
}

const APPROVAL_STATUSID_MAPPER = {
  4: 'APPROVED',
  5: 'PENDING',
  6: 'DECLINED'
};

const DELETE_BEFORE = 7;
const DATE_FORMAT_STRING = 'MM/DD/YYYY';
const CRM_FRONTEND_URL = process.env.REACT_APP_CRM_FRONTEND_URL;

const { STAGE_URL } = process.env;
const MODULE_EXISTS_OFFLINE_MODAL_WARNING_STRING = {
  MODAL_MESSAGE: t('label.unsaved_offline_changes'),
  MODAL_DANGER_BUTTON_TEXT: t('label.yes_dont_sync'),
  MODAL_SECONDARY_BUTTON_TEXT: t('label.cancel_go_back')
};

const CUSTOMER = {
  STRINGS: {
    DEFAULT_TEXT: t('label.dns_customer'),
    DO_NOT_SERVICE_SCHEDULE_JOB: t('label.dns_schedule_job'),
    DO_NOT_SERVICE_PERFORM_ACTIONS: t('label.dns_perform_actions')
  }
};

const LOCAL_STORAGE_KEYS = {
  priceBookFilters: 'priceBookFilters',
  pbItemsLastSyncedAt: 'pbItemsLastSyncedAt',
  pbCategoriesLastSyncedAt: 'pbCategoriesLastSyncedAt',
  FLATRATE_FILTERS: 'flatRateFilters'
};

const PAYMENT_HISTORY_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  DISPUTED: 'DISPUTED'
};

const PRICEBOOK_PAGINATION_DETAILS = {
  PAGE_SIZE: 100
};

const MODULES = {
  CUSTOMER: 'CUSTOMER',
  NOTE: 'NOTE',
  EQUIPMENT: 'EQUIPMENT',
  TICKET: 'TICKET',
  INVOICE: 'INVOICE',
  ESTIMATE: 'ESTIMATE',
  FLAT_RATE: 'FLAT_RATE',
  FORM_TEMPLATE: 'FORM_TEMPLATE',
  FORM: 'FORM',
  USER: 'USER',
  COMPANY: 'COMPANY',
  EQUIPMENT_TEMPLATE_CF: 'EQUIPMENT_TEMPLATE_CF',
  EQUIPMENT_CF: 'EQUIPMENT_CF',
  PAYMENT: 'PAYMENT',
  TIMECARD: 'TIMECARD',
  CLASS: 'CLASS',
  SERVICE_AGREEMENT: 'SERVICE_AGREEMENT'
};

const FP_FORM_EMAIL_TYPE_ID = {
  CUSTOMER : 1,
  OFFICE : 2,
  CUSTOM : 3
};

const FORM_EMAIL_TYPES = {
  CUSTOMER: "CUSTOMER_EMAIL",
  OFFICE: "OFFICE_EMAIL",
  CUSTOM: "CUSTOM_EMAIL"
};

const CHECKLIST_HEADERS = {
  FORMS: "Forms",
  FP_FORMS: "FPForms",
  CHECKLIST: "CheckList"
}

const FP_FORM_DOWNLOAD_STATUS = {
  NOT_REQUESTED: "NOT_REQUESTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}

const ROUTE_CLASSNAME_MAP = {
  [CHECKLIST_HEADERS.FORMS] : 'forms/',
  [CHECKLIST_HEADERS.CHECKLIST]: 'checklist/',
  [CHECKLIST_HEADERS.FP_FORMS]: 'FireProtectionForm/'
}

const MODULE_IDS = {
  TICKET: 6,
  INVOICE: 7,
  ESTIMATE: 8,
  NOTE: 17,
  ADVANCED_SCHEDULER_TRACKING: 21,
  BULK_INVOICE: 22,
  NEW_SCHEDULER: 24,
  PURCHASE_ORDER: 451,
  FP_FORM_TEMPLATE: 32,
  FP_FORM: 33,
  FLAT_RATE: 13,
  EQUIPMENT: 3,
  CUSTOMER: 5,
  SERVICE_AGREEMENT: 23,
  PROJECT: 9,
  MEDIA: 10,
  PROJECT_EXPENSE: 40,
  HOMEPAGE: 51,
  QUESTION_ANSWER: 25,
  FORM: 16,
  SETTINGS: 321
};

const MAX_VIDEO_DURATION_IN_SECONDS = 300;

const MAX_VIDEO_SIZE_IN_MB = 500;

const PRICEBOOK_MODULE_IDS = {
  MATERIALS: '401',
  SERVICE: '402',
  INVENTORYASSEMBLY: '405',
  GROUP: '406'
};

const PRICEBOOK_ITEM_NAMES = {
  1: 'INVENTORY',
  2: 'NON-INVENTORY',
  3: 'SERVICE',
  4: 'INVENTORY-ASSEMBLY',
  5: 'GROUP',
  6: 'GROUP-ITEM'
};

const PRICEBOOK_ITEM_PAGE_SIZE = 100;

const PBITEMS = {
  MATERIALS: {
    NAME: 'Material',
    TYPES: ['INVENTORY', 'NON-INVENTORY'],
    MODULEID: 5,
    ITEMTYPEID: [1, 2]
  },
  SERVICES: {
    NAME: 'Service',
    TYPES: ['SERVICE'],
    MODULEID: 6,
    ITEMTYPEID: 3
  },
  GROUP_ITEM: {
    NAME: 'GroupItem',
    TYPES: ['GROUP'],
    MODULEID: 8,
    ITEMTYPEID: 5
  },
  INVENTORY_ASSEMBLY: {
    NAME: 'InventoryAssembly',
    TYPES: ['INVENTORY-ASSEMBLY'],
    MODULEID: 7,
    ITEMTYPEID: 4
  },
  FLATRATE: {
    MODULEID: 2
  }
};

const ITEM_TITLE_TYPES = {
  CODE: 'Code',
  CODE_DESCRIPTION: 'Code - Description',
  CODE_SECTION: 'Code - Section',
  CODE_SECTION_DESCRIPTION: 'Code - Section - Description'
};

const PRICEBOOK_TABLE_IDS = {
  GROUP: 406
};

const EMAIL_ADDRESS_TYPES = {
  BILLING: {
    label: t('label.billing'),
    value: 'BILLING'
  },
  SERVICE: {
    label: t('label.service'),
    value: 'SERVICE'
  },
  BILLING_AND_SERVICE: {
    label: t('label.both_billing_service'),
    value: 'BOTH'
  },
  CUSTOM: {
    label: t('label.other'),
    value: 'CUSTOM'
  }
};

const DEFAULT_EMAIL_RECIPIENTS = {
  BILLING: 'BILLING',
  SERVICE: 'SERVICE',
  BOTH: 'BOTH',
  CUSTOM: 'CUSTOM'
};

const FP_FORMS = {
  CUSTOM_PREFIX: 'custom_',
  SECTION_ACTION: {
    PREVIOUS: 'previous',
    NEXT: 'next'
  }
};

const USER_ROLES = {
  ADMIN: 0,
  DISPATCHER: 1,
  TECHNICIAN: 2,
  SERVICE_MANAGER: 3,
  HELPER: 4,
  TECHNICIAN_RESTRICTED: 5,
  VIEW_RESTRICTED: 6,
  BILLING_RESTRICTED: 7
};

const INVOICE_STATUS_COLOR_MAP = {
  'Open': '#00c5ff',
  'Complete': '#00ff00',
  'Voided': '#ff3333',
  'Void': '#ff3333',
  'Sold': "#ff9900"
};

const CUSTOM_ERROR_CODES = {
  "E100": "ValidationError",
  "E101": "RestrictionError",
  "E102": "FattmerchantError",
  "E103": "MultipleSessionsError",
  "E104": "OverwriteError",
  "QBO100": "ValidatoinError",
  "E403": "AclError",
  "E404": "Route not Found"
};

const LIMITS = {
  TICKETS_PER_PAGE: 20,
};

const DATE_TIME_FORMATS = {
  "DEFAULT_DATE":"MMM Do, YYYY", 
  "TIME_24":"hh:mm",
  "TIME_12":"hh:mm a"
};

export {
  PRICEBOOK_PAGINATION_DETAILS,
  CUSTOMER,
  MAX_VIDEO_SIZE_IN_MB,
  MAX_VIDEO_DURATION_IN_SECONDS,
  SUPPORTED_VIDEO_FILE_MIME_TYPE,
  SUPPORTED_FILE_MIME_TYPE,
  ACCEPTED_FILE_TYPES,
  BASE_URL,
  GOOGLE_API_KEY,
  ESTIMATE_ACTION_KEYS,
  ESTIMATE_ACTIONS,
  INVOICE_ACTION_KEYS,
  INVOICE_ACTIONS,
  US_STATES,
  CANADA_STATES,
  BILLING_PDF_EMAIL,
  PSPDF_KEY,
  NEW_OBJECT_DEFAULT_IDS,
  GRAVITY_PAYMENT_APPROVED_URL,
  GRAVITY_PAYMENT_DECLINED_URL,
  DATABASE_VERSION,
  DATABASE_NAME,
  PROFILES,
  Payment_STATUS_IDS,
  ITEM_TYPE_IDS,
  ITEM_TYPES,
  emailType,
  BILLING_TYPE,
  BILLING_STATUS,
  BILLING_STATUS_ID,
  SPIFF_STATUS,
  SPIFF_STATUS_ID,
  OFFLINE_DATABASE,
  DELETE_BEFORE,
  ACTIONS,
  DATE_FORMAT_STRING,
  APPROVAL_STATUS,
  LINEITEM_STATUS,
  APPROVAL_STATUSID_MAPPER,
  LOCATION_URL,
  MODULE_EXISTS_OFFLINE_MODAL_WARNING_STRING,
  CRM_FRONTEND_URL,
  STAGE_URL,
  TINYMCE_API_KEY,
  PAYMENT_HISTORY_STATUS,
  MODULES,
  LOCAL_STORAGE_KEYS,
  FP_FORM_EMAIL_TYPE_ID,
  FORM_EMAIL_TYPES,
  CHECKLIST_HEADERS,
  ROUTE_CLASSNAME_MAP,
  MODULE_IDS,
  PRICEBOOK_MODULE_IDS,
  PRICEBOOK_ITEM_NAMES,
  PBITEMS,
  PRICEBOOK_TABLE_IDS,
  DEFAULT_EMAIL_RECIPIENTS,
  FP_FORMS,
  USER_ROLES,
  ITEM_TITLE_TYPES,
  PRICEBOOK_ITEM_PAGE_SIZE,
  EMAIL_ADDRESS_TYPES,
  ASSIGNMENT_STATUS_NAME,
  VISIT_CANCEL_REASON_MIN_LENGTH,
  VISIT_CANCEL_REASON_MAX_LENGTH,
  INVOICE_STATUS_COLOR_MAP,
  PLACEHOLDER_CLASS,
  CUSTOM_ERROR_CODES,
  LIMITS,
  DATE_TIME_FORMATS,
  FP_FORM_DOWNLOAD_STATUS,
};
